import { cn } from '@/lib/utils';
import { Label } from './label';

interface FieldProps {
  id: string;
  label: string;
  hint?: string;
  error?: string | undefined;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function Field({ id, label, hint, error, required, className, children }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      {children}
      {hint && !error && <p className="text-xs text-steel">{hint}</p>}
      {error && <p className="text-xs text-rust" role="alert">{error}</p>}
    </div>
  );
}
